import { ExtendsMainComponent } from '../extends/extends-main.component';

import { SignUpComponent } from './sign-up.component';
import { Compiler, Component, NgModule, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { WaitModalComponent } from '../wait-modal/wait-modal.component';
import { Router } from '@angular/router';
import { DocumentModalComponent } from '../document-modal/document-modal.component';

import { SignUpService } from '../../service/sign-up.service';
import { TokenManager } from '../../service/web-api.service';
import { WebApiService } from '../../service/web-api.service';
import { DisplayService } from '../../service/display.service';
import { DocumentService } from '../../service/document.service';
import { MfaTelephoneService } from '../../service/mfa-telephone.service';
import { AuthService } from '../../service/auth.service';
import { CheckItemService, CheckItemIn } from '../../service/checkItem.service';
import { MfaTelephoneModalComponent } from '../mfa-telephone-modal/mfa-telephone-modal.component';

import { environment } from '../../../environments/environment';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/interval';
import 'rxjs/add/observable/fromEvent';

declare let gtag: any; // グローバル変数gtagを解決

export class SignUpMainComponent extends ExtendsMainComponent {

  private waitModal: WaitModalComponent;
  private documentModal: DocumentModalComponent;
  private mfaTelephoneModal: MfaTelephoneModalComponent;
  private timer: Subscription;

  private signUpComponent: SignUpComponent;
  private signUpService: SignUpService;
  private checkItemService: CheckItemService;
  private documentService: DocumentService;
  private mfaTelephoneService: MfaTelephoneService;
  private authService: AuthService;

  private checkItemIn: CheckItemIn;

  // タイトルロゴ
  public dispZ0001: string;
  // アカウント作成時のメッセージ
  public dispO0201: string;

  // 画面項目定義
  public email: string;
  public mailCheckCode: string;
  public userId: string;
  public password: string;
  public confirmPassword: string;
  public consentDisabled: boolean;
  public extensionConsent: boolean;
  public birthdate: string;
  public birthdateYear: string;
  public birthdateMonth: string;
  public birthdateDay: string;
  public familyName: string;
  public givenName: string;
  public phoneNumber: string;
  public messages: any;
  public emailDisabled: boolean;
  public userIdDisabled: boolean;
  public birthdateDisabled: boolean;
  public familyNameDisabled: boolean;
  public givenNameDisabled: boolean;
  public phoneNumberDisabled: boolean;
  public documentInfoList: any[];

  public formatBirthdate: string;

  public smartInTelephoneNumber: string;

  public normalDisplay: string;
  public errDisplay: string;

  public mfaRequired: boolean;

  public passDispType: string;

  // 年月日セレクトボックス用変数
  public yearList: any[];
  public selectedYear: string;
  public monthList: any[];
  public selectedMonth: string;
  public dateList: any[];
  public selectedDate: string;

  // パスワード充足チェックパターン
  public patternCount;
  public patternSmallChar;
  public patternLargeChar;
  public patternNum;
  public patternSymbol;

  // パスワード充足チェック結果
  public countResult: boolean;
  public smallCharResult: boolean;
  public largeCharResult: boolean;
  public numResult: boolean;
  public symbolResult: boolean;
  public haveEnoughConditions: boolean;

  public isFromThisDevice: boolean;

  init(_signUpComponent: SignUpComponent, _signUpService: SignUpService,
    _checkItemService: CheckItemService, _waitModal: WaitModalComponent,
    _authService: AuthService, _documentService: DocumentService, _mfaTelephoneService: MfaTelephoneService,
    _documentModal: DocumentModalComponent, _mfaTelephoneModal: MfaTelephoneModalComponent) {

    this.config();

    this.signUpService = _signUpService;
    this.checkItemService = _checkItemService;
    this.documentService = _documentService;
    this.mfaTelephoneService = _mfaTelephoneService;
    this.waitModal = _waitModal;
    this.authService = _authService;
    this.documentModal = _documentModal;
    this.mfaTelephoneModal = _mfaTelephoneModal;

    this.signUpComponent = _signUpComponent;
    this.dispZ0001 = this.signUpComponent.dispZ0001;
    this.dispO0201 = this.signUpComponent.dispO0201;
    this.documentInfoList = this.signUpComponent.documentInfoList;

    this.email = this.signUpComponent.email;
    this.userId = this.signUpComponent.userId;
    this.password = this.signUpComponent.password;
    this.confirmPassword = this.signUpComponent.confirmPassword;
    this.consentDisabled = this.signUpComponent.consentDisabled;
    this.extensionConsent = this.signUpComponent.extensionConsent;
    this.birthdate = this.signUpComponent.birthdate;
    this.birthdateYear = this.signUpComponent.birthdateYear;
    this.birthdateMonth = this.signUpComponent.birthdateMonth;
    this.birthdateDay = this.signUpComponent.birthdateDay;
    this.familyName = this.signUpComponent.familyName;
    this.givenName = this.signUpComponent.givenName;
    this.phoneNumber = this.signUpComponent.phoneNumber;
    this.messages = [];
    this.emailDisabled = this.signUpComponent.emailDisabled;
    this.userIdDisabled = this.signUpComponent.userIdDisabled;
    this.birthdateDisabled = this.signUpComponent.birthdateDisabled;
    this.familyNameDisabled = this.signUpComponent.familyNameDisabled;
    this.givenNameDisabled = this.signUpComponent.givenNameDisabled;
    this.phoneNumberDisabled = this.signUpComponent.phoneNumberDisabled;
    this.haveEnoughConditions = this.signUpComponent.haveEnoughConditions;
    this.countResult = this.signUpComponent.countResult;

    this.formatBirthdate = '';

    this.smartInTelephoneNumber = environment.smartInTelephoneNumber;

    this.normalDisplay = '';
    this.errDisplay = 'none';

    this.mfaRequired = this.signUpComponent.mfaRequired;

    this.passDispType = 'password';

    this.isFromThisDevice = true;

    // セレクトボックス表示用の年月日のリストと初期値設定
    this.yearList = this.createYearList();
    this.selectedYear = (new Date().getFullYear() - 30).toString();

    this.monthList = this.createMonthList();
    this.selectedMonth = '01';

    this.dateList = this.createDayList();
    this.selectedDate = '01';

    this.patternCount = new RegExp('^.{8,64}$');
    this.patternSmallChar = new RegExp('.*[a-z]+.*');
    this.patternLargeChar = new RegExp('.*[A-Z]+.*');
    this.patternNum = new RegExp('.*[0-9]+.*');
    // 文字列リテラルの場合でエスケープするためには"\(バックスラッシュ)"が2つ必要
    this.patternSymbol = new RegExp('.*[@#\\$%\\^&\\*\\-_\\+=\\[\\]\\{\\}\\|\\:\',\\?\\/`~\\"\\(\\);\\.!]+.*');

    // 画面切り替え時に電話認証をする場合の処理
    if (this.signUpComponent.isMfaPage && this.signUpComponent.mfaRequired) {
      this.execMfaPhone();
      this.signUpComponent.isMfaPage = false;
    }
  }

  /**
   * 次へ
   *
   * @param checkItem チェック対象項目
   * @param isRequiredArray 必須チェック対象項目
   * @param isMfaPage 次画面が電話認証画面の場合true
   * @param toUseBirthdateSelectbox 生年月日セレクトボックスを使う場合はtrue
   */
  next(checkItem: string[], isRequiredArray?: string[], isMfaPage?: boolean, toUseBirthdateSelectbox?: boolean) {

    this.email = this.email.toLowerCase().trim();
    this.userId = this.userId.trim();

    // 選択された生年月日を一個の文字列に結合
    if (toUseBirthdateSelectbox) {
      this.birthdate = this.selectedYear + this.selectedMonth + this.selectedDate;
    }

    // パラメータ設定
    this.checkItemIn = new CheckItemIn();

    for (const item of checkItem) {
      switch (item) {
        case 'mailAddress':
          this.checkItemIn.mailAddress = this.email;
          break;
        case 'userId':
          this.checkItemIn.userId = this.userId;
          break;
        case 'password':
          this.checkItemIn.password = this.password;
          this.checkItemIn.confirmPassword = this.confirmPassword;
          this.checkItemIn.mailAddress = this.email;
          this.checkItemIn.userId = this.userId;
          break;
        case 'consentInfo':
          this.checkItemIn.consentInfo = this.extensionConsent + '';
          break;
        case 'birthdate':
          this.execBirthdateFormat();
          this.checkItemIn.birthdate = this.formatBirthdate;
          break;
        case 'familyName':
          this.checkItemIn.familyName = this.familyName;
          break;
        case 'givenName':
          this.checkItemIn.givenName = this.givenName;
          break;
        case 'phoneNumber':
          this.checkItemIn.phoneNumber = this.phoneNumber;
          break;
      }
    }
    this.waitModal.showModal();

    // チェック処理
    this.checkItemService.execAuthCheckItem(this.checkItemIn, isRequiredArray).subscribe(result => {
      this.waitModal.hideModal();

      if (result == null) {
        this.messages = [];

        // 引継ぎ項目
        this.signUpComponent.email = this.email;
        this.signUpComponent.userId = this.userId;
        this.signUpComponent.password = this.password;
        this.signUpComponent.confirmPassword = this.confirmPassword;
        this.signUpComponent.consentDisabled = this.consentDisabled;
        this.signUpComponent.extensionConsent = this.extensionConsent;
        this.signUpComponent.birthdate = this.birthdate;
        this.signUpComponent.birthdateYear = this.birthdateYear;
        this.signUpComponent.birthdateMonth = this.birthdateMonth;
        this.signUpComponent.birthdateDay = this.birthdateDay;
        this.signUpComponent.familyName = this.familyName;
        this.signUpComponent.givenName = this.givenName;
        this.signUpComponent.phoneNumber = this.phoneNumber;
        this.signUpComponent.emailDisabled = this.emailDisabled;
        this.signUpComponent.userIdDisabled = this.userIdDisabled;
        this.signUpComponent.birthdateDisabled = this.birthdateDisabled;
        this.signUpComponent.familyNameDisabled = this.familyNameDisabled;
        this.signUpComponent.givenNameDisabled = this.givenNameDisabled;
        this.signUpComponent.phoneNumberDisabled = this.phoneNumberDisabled;
        this.signUpComponent.pageNo++;
        this.signUpComponent.haveEnoughConditions = this.haveEnoughConditions;
        this.signUpComponent.countResult = this.countResult;

        // 次画面で電話認証をする場合
        if (isMfaPage && this.mfaRequired) {
          // 画面切り替え時に電話認証リクエストを送信するフラグをtrueにする
          this.signUpComponent.isMfaPage = true;
          // 次画面で電話認証をしない場合
        } else if (isMfaPage && !this.mfaRequired) {
          // 画面切り替え時に次画面（電話認証画面）をスキップする
          this.signUpComponent.pageNo++;
        }

        // 画面切り替え
        this.signUpComponent.directInjection();

      } else {
        this.messages = result;
        this.scrollError('sign_up_check_item_error', result);
      }
    });
  }

  /**
   * 同じ番号で再度電話認証する
   */
  reMfaPhone() {
    this.waitModal.showModal();

    // 表示する要素を切り替える
    this.messages = [];
    this.normalDisplay = '';
    this.errDisplay = 'none';

    this.waitModal.hideModal();
    this.execMfaPhone();
  }

  private execMfaPhone() {
    // 電話認証準備
    this.mfaTelephoneService.execMfaTelephonePre(this.phoneNumber).subscribe(resultPre => {
      if (resultPre == null) {
        this.messages = [];
        let errCount = 0;
        // 電話認証結果確認：結果のポーリング開始
        this.timer = Observable.interval(2000).subscribe(() => {
          this.mfaTelephoneService.execMfaTelephoneConfirm(null).subscribe(
            resultConf => {
              if (resultConf.result) {
                switch (resultConf.code) {
                  case '00':
                    // 電話認証OKならばポーリングを停止し次の画面へ遷移
                    this.messages = [];
                    this.timer.unsubscribe();
                    this.next([]);
                    return;
                  case '99':
                  // 電話待ち状態であればポーリング継続
                }
                // タイムアウトエラー時
              } else {

                // 表示する要素を切り替える
                this.normalDisplay = 'none';
                this.errDisplay = '';
                // ポーリングを停止しエラーメッセージ表示
                this.messages = resultConf.messages;
                this.timer.unsubscribe();
                this.scrollError('phone_confirm_error', this.messages);
                return;
              }
            },
            //// エラー時処理
            error => {
              if (error.status === 401) {
                // ポーリングを停止しエラー画面遷移
                this.timer.unsubscribe();
                this.signUpComponent.router.navigate(['/error', error.status]);
                return;
              }
              if (error.status === 400) {
                if (errCount <= 2) {
                  // 400エラー発生3回までカウントし、エラーを無視する
                  errCount++;
                  return;
                }
                // ポーリングを停止しエラー画面遷移
                this.timer.unsubscribe();
                this.signUpComponent.router.navigate(['/error', error.status]);
                return;
              }
            });
        });
      } else {
        this.messages = resultPre;
        // 表示する要素を切り替える
        this.normalDisplay = 'none';
        this.errDisplay = '';
        this.scrollError('phone_prerequest_error', this.messages);
        return;
      }
    });
  }

  /**
   * イベント：戻る
   */
  back(backPageNumber: number) {
    // 戻るページ数の設定
    if (backPageNumber) {
      this.signUpComponent.pageNo = this.signUpComponent.pageNo - backPageNumber;
    } else {
      this.signUpComponent.pageNo--;
    }

    // 画面切り替え
    this.signUpComponent.directInjection();
    // timerオブジェクトがあるときはポーリングを停止する
    if (this.timer) {
      this.timer.unsubscribe();
    }
  }

  /**
   * イベント：認証画面遷移
   */
  toSignIn() {
    this.signUpComponent.router.navigate(['sign-in']);
  }

  /**
   * イベント：アプリへ戻るボタン押下
   */
  cancel() {
    this.locationAssign('/oauth/v2/authorization/cancel?' + TokenManager.getToken());
  }

  /**
   * イベント：KFG画面の電話をかけるボタン押下
   */
  phoneCall(isFromThisDevice: boolean, checkItem: string[], isRequiredArray?: string[]) {
    // パラメータ設定
    this.checkItemIn = new CheckItemIn();

    for (const item of checkItem) {
      switch (item) {
        case 'consentInfo':
          this.checkItemIn.consentInfo = this.extensionConsent + '';
          break;
        case 'phoneNumber':
          this.checkItemIn.phoneNumber = this.phoneNumber;
          break;
      }
    }
    this.waitModal.showModal();

    // チェック処理
    this.checkItemService.execAuthCheckItem(this.checkItemIn, isRequiredArray).subscribe(checkResult => {
      this.waitModal.hideModal();

      if (checkResult == null) {
        this.messages = [];

        // 引継ぎ項目
        this.signUpComponent.consentDisabled = this.consentDisabled;
        this.signUpComponent.extensionConsent = this.extensionConsent;
        this.signUpComponent.phoneNumber = this.phoneNumber;
        this.signUpComponent.phoneNumberDisabled = this.phoneNumberDisabled;

        // 電話認証モーダル表示
        this.isFromThisDevice = isFromThisDevice;
        this.mfaTelephoneModal.showMfaTelephoneModalPage1(this.phoneNumber).subscribe(
          result => {
            // 「はい」ボタン押下時
            if (result) {
              // 他の端末から電話をかける場合
              if (!isFromThisDevice) {
                // 2番目のモーダル表示
                this.mfaTelephoneModal.showMfaTelephoneModalPage2().subscribe(resultAnotherDevice => {
                  // キャンセルボタン押下時はポーリング停止
                  if (!resultAnotherDevice) {
                    this.timer.unsubscribe();
                    this.mfaTelephoneModal.hideMfaTelephoneModal();
                    return;
                  }
                  // 電話認証
                  this.execMfaPhoneModal(isFromThisDevice);
                });
              }
              // この端末から電話をかける場合
              // 電話認証準備
              this.execMfaPhoneModal(isFromThisDevice);
            } else {
              // 「いいえ」ボタン押下時
              this.mfaTelephoneModal.hideMfaTelephoneModal();
            }
          }
        );

      } else {
        this.messages = checkResult;
        this.scrollError();
      }
    });
  }

  /**
  * KFGの電話認証共通処理
  */
  private execMfaPhoneModal(isFromThisDevice: boolean) {
    // 電話認証準備
    this.mfaTelephoneService.execMfaTelephonePre(this.phoneNumber).subscribe(resultPre => {
      if (resultPre == null) {
        if (isFromThisDevice) {
          this.onClickTelephoneCall();
        }
        this.messages = [];
        let errCount = 0;
        // 電話認証結果確認：結果のポーリング開始
        this.timer = Observable.interval(2000).subscribe(() => {
          this.mfaTelephoneService.execMfaTelephoneConfirm(null).subscribe(
            resultConf => {
              if (resultConf.result) {
                switch (resultConf.code) {
                  case '00':
                    // 電話認証OKならばポーリングを停止し次の画面へ遷移
                    this.mfaTelephoneModal.hideMfaTelephoneModal();
                    this.messages = [];
                    this.timer.unsubscribe();
                    this.next([]);
                    return;
                  case '99':
                  // 電話待ち状態であればポーリング継続
                }
                // タイムアウトエラー時
              } else {
                // 表示する要素を切り替える
                this.mfaTelephoneModal.hideMfaTelephoneModal();
                this.normalDisplay = 'none';
                this.errDisplay = '';
                // ポーリングを停止しエラーメッセージ表示
                this.messages = resultConf.messages;
                this.timer.unsubscribe();
                this.scrollError('phone_confirm_error', this.messages);
                return;
              }
            },
            //// エラー時処理
            error => {
              if (error.status === 401) {
                // ポーリングを停止しエラー画面遷移
                this.mfaTelephoneModal.hideMfaTelephoneModal();
                this.timer.unsubscribe();
                this.signUpComponent.router.navigate(['/error', error.status]);
                return;
              }
              if (error.status === 400) {
                if (errCount <= 2) {
                  // 400エラー発生3回までカウントし、エラーを無視する
                  errCount++;
                  return;
                }
                // ポーリングを停止しエラー画面遷移
                this.mfaTelephoneModal.hideMfaTelephoneModal();
                this.timer.unsubscribe();
                this.signUpComponent.router.navigate(['/error', error.status]);
                return;
              }
            });
        });
      } else {
        this.mfaTelephoneModal.hideMfaTelephoneModal();
        this.messages = resultPre;
        // 表示する要素を切り替える
        this.normalDisplay = 'none';
        this.errDisplay = '';
        this.scrollError('phone_prerequest_error', this.messages);
        return;
      }
    });
  }

  /**
   * イベント：KFG画面の同じ電話番号で再認証するボタン押下
   */
  retryMfaPhone() {
    // 表示する要素を切り替える
    this.normalDisplay = '';
    this.errDisplay = 'none';
    // 再認証
    this.phoneCall(this.isFromThisDevice, []);
  }

  /**
 * イベント：KFG画面の電話番号の編集ボタン押下
 */
  editPhoneNumber() {
    this.messages = [];
    // 表示する要素を切り替える
    this.normalDisplay = '';
    this.errDisplay = 'none';
  }



  /**
   * イベント：メール送信
   *
   * @param isNext 次ページ遷移　true:遷移/false:遷移なし
   */
  sendMail(isNext: boolean, isSeq?: boolean) {
    this.messages = [];
    this.waitModal.showModal();
    let pageNo = null;

    // メールリンクから直接処理を継続する場合
    if (isSeq) {
      pageNo = this.signUpComponent.pageNo + 2;
    }

    this.email = this.email.toLowerCase().trim();

    // 引継ぎ情報作成
    this.signUpService.execAuthSendMail(this.email, this.signUpComponent.SCREEN_ID, pageNo, this.generateNextParameter())
      .subscribe(result => {
        this.waitModal.hideModal();
        if (result == null) {
          this.messages = [];
          if (isNext) {
            this.next([]);
          }
        } else {
          this.messages = result;
          this.scrollError();
        }
      });
  }

  /**
   * イベント：メール認証チェック
   *
   */
  checkMail() {
    this.messages = [];
    this.waitModal.showModal();

    this.signUpService.execAuthCheckMail().subscribe(result => {
      this.waitModal.hideModal();
      if (result == null) {
        this.messages = [];
        this.next([]);
      } else {
        this.messages = result;
        this.scrollError();
      }
    });
  }

  /**
   * イベント：利用規約リンク押下
   *
   * @param consentNo 利用規約No
   * @param total 総数
   */
  consent(consentNo: number, total: number) {

    this['consent' + consentNo] = true;

    // Disabled解除
    this.consentDisabled = false;
    for (let i = 1; i <= total; i++) {
      // 読まれていない利用規約が存在する場合
      if (!this['consent' + i]) {
        this.consentDisabled = true;
        break;
      }
    }
  }

  /**
  * イベント：利用規約リンク押下（モーダルで規約表示）
  *
  * @param name 利用規約名
  * @param url 利用規約のURL
  * @param consentNo 何番目の規約か
  * @param total 既読必須の場合、総数
  */
  consentWithModal(name: string, url: string, consentNo: number, total?: number) {

    // 画面側でこのフラグを利用してリンクの色を変更する
    this['consent' + consentNo] = true;

    // 規約モーダル表示
    this.documentModal.showModal(name, url).subscribe(
      result => {
        if (result) {
          // 何もしない
        }
      }
    );
    // モーダルの閉じるボタンで閉じなくても既読判定するように表示処理の外で既読判定する
    if (total !== undefined) {
      // Disabled解除
      this.consentDisabled = false;
      for (let i = 1; i <= total; i++) {
        // 読まれていない利用規約が存在する場合
        if (!this['consent' + i]) {
          this.consentDisabled = true;
          break;
        }
      }
    }
  }

  /**
   * イベント：登録（既読登録）
   *
   * @param isNext 次ページ遷移　true:遷移/false:遷移なし
   */
  registerReadDocument(isNext: boolean) {
    this.messages = [];
    this.waitModal.showModal();

    // 生年月日フォーマット
    this.execBirthdateFormat();

    this.email = this.email.toLowerCase().trim();
    this.userId = this.userId.trim();

    this.signUpService.execAuthRegisterAccount(this.userId, this.password, this.confirmPassword,
      this.email, this.extensionConsent, this.formatBirthdate, this.familyName, this.givenName, this.phoneNumber).subscribe(result => {
        if (result == null) {
          // GAで集計する
          gtag('event', 'sign_up');
          this.messages = [];
          this.documentService.execAuthRegisterReadDocument(this.documentInfoList).subscribe(resultDocument => {
            if (isNext) {
              this.next([]);
            } else {
              this.complete();
            }
          });
        } else {
          this.waitModal.hideModal();
          this.messages = result;
          this.scrollError();
        }
      });
  }

  /**
   * イベント：登録
   *
   * @param isNext 次ページ遷移　true:遷移/false:遷移なし
   */
  register(isNext: boolean) {
    this.messages = [];
    this.waitModal.showModal();

    // 生年月日フォーマット
    this.execBirthdateFormat();

    this.email = this.email.toLowerCase().trim();
    this.userId = this.userId.trim();

    this.signUpService.execAuthRegisterAccount(this.userId, this.password, this.confirmPassword,
      this.email, this.extensionConsent, this.formatBirthdate, this.familyName, this.givenName, this.phoneNumber).subscribe(result => {
        // GAで集計する
        gtag('event', 'sign_up');
        this.waitModal.hideModal();
        if (result == null) {
          this.messages = [];
          if (isNext) {
            this.next([]);
          } else {
            this.complete();
          }
        } else {
          this.messages = result;
          this.scrollError();
        }
      });
  }

  /**
    * イベント：登録完了
    */
  complete() {
    this.waitModal.showModal();

    // URL作成
    let url = '';
    if (this.authService.isV2) {
      url = environment.apiServerBaseUrl + '/v2/authorization/issue?' + TokenManager.getToken();
    } else {
      url = environment.apiServerBaseUrl + '/authorization/issue?' + TokenManager.getToken();
    }
    // パラメータ作成
    const param = { 'screen_id': this.signUpComponent.SCREEN_ID };

    // submitを実行
    this.onSubmit(url, param);
    this.waitModal.hideModal();
  }


  /**
   * 生年月日の項目がひとつの場合、年月日の項目に分割
   * ハイフン区切り
   */
  execBirthdateFormat() {

    let formatY = '';
    let formatM = '';
    let formatD = '';
    this.formatBirthdate = '';

    if (this.birthdate !== '') {
      // -または/が含まれない場合
      if (this.birthdate.search('[\-/]+') === -1) {
        formatY = this.birthdate.substring(0, 4);
        formatM = this.birthdate.substring(4, 6);
        formatD = this.birthdate.substring(6, 8);
      } else {
        let arrayBirth: any;
        if (this.birthdate.indexOf('-') !== -1) {
          arrayBirth = this.birthdate.split('-');
        } else if (this.birthdate.indexOf('/') !== -1) {
          arrayBirth = this.birthdate.split('/');
        }
        formatY = arrayBirth[0];
        formatM = arrayBirth[1];
        formatD = arrayBirth[2];
      }
      formatY = ('0000' + formatY).slice(-4);
      formatM = ('00' + formatM).slice(-2);
      formatD = ('00' + formatD).slice(-2);
      this.formatBirthdate = formatY + '-' + formatM + '-' + formatD;
      this.birthdateYear = formatY;
      this.birthdateMonth = formatM;
      this.birthdateDay = formatD;

    } else if (this.birthdateYear !== '' || this.birthdateMonth !== '' || this.birthdateDay !== '') {
      // 各項目にフォーマットした情報を設定
      this.birthdateYear = ('0000' + this.birthdateYear).slice(-4);
      this.birthdateMonth = ('00' + this.birthdateMonth).slice(-2);
      this.birthdateDay = ('00' + this.birthdateDay).slice(-2);

      this.formatBirthdate = this.birthdateYear + '-' + this.birthdateMonth + '-' + this.birthdateDay;
    }
  }

  /**
  * パスワードの表示・非表示を切り替える
  */
  switchPassDisp() {
    // 表示する
    if (this.passDispType === 'password') {
      this.passDispType = 'text';
      return;
    }
    // 非表示にする
    if (this.passDispType === 'text') {
      this.passDispType = 'password';
      return;
    }
  }

  /**
   * 引継ぎ用情報をJson形式で作成します。
   */
  private generateNextParameter(): string {

    // 引継ぎ情報objectを作成
    const jsonObj = {
      email: { 'value': this.email, 'fixed': this.emailDisabled },
      name: { 'value': this.userId, 'fixed': this.userIdDisabled },
      birthdate: { 'value': this.birthdate, 'fixed': this.birthdateDisabled },
      birthdate_year: this.birthdateYear,
      birthdate_month: this.birthdateMonth,
      birthdate_day: this.birthdateDay,
      family_name: { 'value': this.familyName, 'fixed': this.familyNameDisabled },
      given_name: { 'value': this.givenName, 'fixed': this.givenNameDisabled },
      phone_number: { 'value': this.phoneNumber, 'fixed': this.phoneNumberDisabled },
      password: this.password,
      confirm_password: this.confirmPassword,
      consent_disabled: this.consentDisabled,
      extension_consent: this.extensionConsent,
      document_info_list: this.documentInfoList
    };

    // objectをjsonにパース
    return JSON.stringify(jsonObj);
  }

  /**
   * イベント：この端末から電話をかける
   */
  onClickTelephoneCall() {
    location.href = 'tel:' + this.smartInTelephoneNumber + '';
  }

  /**
   * セレクトボックス用年数リストを返却
   * @returns 年数リスト
   */
  private createYearList() {
    const nowYear = new Date().getFullYear();
    const yearList = [];

    for (let i = 1900; i <= nowYear; i++) {
      yearList.push({ name: i.toString(), value: i.toString() });
    }

    return yearList;
  }

  /**
   * セレクトボックス用月リストを返却
   * @returns 月リスト
   */
  private createMonthList() {
    const monthList = [];
    for (let i = 1; i <= 12; i++) {
      let m = '';
      if (i < 10) {
        m = '0' + i.toString();
      } else {
        m = i.toString();
      }
      monthList.push({ name: m, value: m });
    }

    return monthList;
  }

  /**
* セレクトボックス用日リストを返却
* @returns 日リスト
*/
  private createDayList() {
    const dayList = [];

    for (let i = 1; i <= 31; i++) {
      let m = '';
      if (i < 10) {
        m = '0' + i.toString();
      } else {
        m = i.toString();
      }
      dayList.push({ name: m, value: m });
    }

    return dayList;
  }

  /**
   * 設定されたパスワードをチェックする
   */
  passwordCheck() {
    this.countResult = this.patternCount.test(this.password);
    this.smallCharResult = this.patternSmallChar.test(this.password);
    this.largeCharResult = this.patternLargeChar.test(this.password);
    this.numResult = this.patternNum.test(this.password);
    this.symbolResult = this.patternSymbol.test(this.password);

    let conditionCount = 0;

    if (this.smallCharResult) {
      conditionCount++;
    }
    if (this.largeCharResult) {
      conditionCount++;
    }
    if (this.numResult) {
      conditionCount++;
    }
    if (this.symbolResult) {
      conditionCount++;
    }
    if (conditionCount >= 2) {
      this.haveEnoughConditions = true;
    } else {
      this.haveEnoughConditions = false;
    }

  }
}
